var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 144,
    viewBox: "0 0 122 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.8154 141V142.5H21.3154H34.5905H36.0905V141V3V1.5H34.5905H25.2114H24.2565L23.8523 2.36509C22.4682 5.3277 20.6403 8.17637 18.3598 10.9107L18.3549 10.9165L18.3501 10.9224C16.1043 13.6711 13.6516 16.1281 10.9921 18.2958C8.37768 20.4003 5.83936 22.0027 3.37831 23.1235L2.36799 23.5836L2.51282 24.6843L4.82154 42.23L5.08594 44.2394L6.9304 43.3994C9.06206 42.4286 11.2895 41.091 13.6117 39.4034C15.3766 38.1208 17.4467 36.2453 19.8154 33.8034V141ZM57.7152 140.548L57.0982 142.5H59.1455H73.5749H74.6732L75.0049 141.453L118.726 3.45304L119.345 1.5H117.296H51.9307H50.4307V3V20.7429V22.2429H51.9307H95.1098L57.7152 140.548Z",
    stroke: "#757575",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg17);
export default __webpack_public_path__ + "static/media/17.3766f434cb3a907b1398ed5ec1c746f4.svg";
export { ForwardRef as ReactComponent };